import React from 'react';
import styled, { css } from 'styled-components';

/*
 * RES-1367: `$compact` is the booking-details card's column -- see the credits-free twin,
 * `compactPaymentBlock` in components/payment/receipt/components/styles.ts, for what it means. The
 * 26px lead-in is a receipt pane's; in a column the card above has already set the distance.
 */
const Container = styled.div<{ $compact?: boolean }>`
  margin-top: ${({ $compact }) => ($compact ? '0' : '26px')};
  background: ${({ theme }) => theme.colors.$white};
  box-sizing: border-box;
`;

const Title = styled.div<{ $compact?: boolean }>`
  ${({ $compact, theme }) =>
    $compact
      ? css`
          font: 600 13px/1 ${theme.fonts.join()};
          color: ${theme.colors.palette.systemGreyDark};
          margin-bottom: 8px;
        `
      : css`
          font: 700 16px/19px ${theme.fonts.join()};
          color: ${theme.colors.fontColor};
          margin-bottom: 16px;
        `}
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const ItemName = styled.div`
  font: 400 14px/16px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
`;

const ItemPrice = styled.div`
  font: 600 14px/16px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
`;

interface CreditsPaymentDetailsProps {
  itemName: string;
  itemPrice: string;
  title?: string;
  /* RES-1367: see Container above. Defaults to false, so checkout is unaffected. */
  compact?: boolean;
}

export const CreditsPaymentDetails = ({
  itemName,
  itemPrice,
  title,
  compact = false,
}: CreditsPaymentDetailsProps): JSX.Element => {
  return (
    <Container data-testid="credits-payment-details" $compact={compact}>
      {title && <Title $compact={compact}>{title}</Title>}
      <ItemRow>
        <ItemName>{itemName}</ItemName>
        <ItemPrice>{itemPrice}</ItemPrice>
      </ItemRow>
    </Container>
  );
};
